module.exports = __webpack_public_path__ + "img/1567756609.e6152944.jpg";